import classNames from 'classnames';
import Button from '@hiredigital/ui/Button';
import SectionContainer from '@components/Section/Container';
import Section from '@components/Section/Section';
import Text from '@hiredigital/ui/Text/Text';
import Styles from './CardSection.module.scss';

const CardItem = ({ card }) => {
  return (
    <div className={Styles.cardItem}>
      {card.icon && (
        <img className={Styles.cardIcon} loading='lazy' src={card.icon.url} alt='icon' />
      )}
      <h3 className={Styles.cardTitle}>{card.title}</h3>
      <div
        className={Styles.cardDesc}
        dangerouslySetInnerHTML={{ __html: card?.description?.html }}
      />
    </div>
  );
};

/*
  There will be several options that dictate how this looks
  style
  columns (ltr only)
*/
const CardSection = ({ section, ind }) => {
  const { style, columns, title, description, cards, buttons, backgroundColor } = section;
  return (
    <SectionContainer
      className={Styles[`style${style}`]}
      style={{ backgroundColor: backgroundColor?.hex }}>
      <Section title={title}>
        <Text
          element='div'
          size={Text.Size.BODY}
          dangerouslySetInnerHTML={{ __html: description?.html }}
        />

        <div className={classNames(Styles.cardList, Styles[`cols${columns}`])}>
          {cards.map((card, index) => (
            <CardItem card={card} key={index} />
          ))}
        </div>
        <div className={Styles.buttonList}>
          {buttons?.map((button, index) => (
            <Button type={Button.Type.BLUE} size={Button.Size.LARGE} href={button.url} key={index}>
              {button.label}
            </Button>
          ))}
        </div>
      </Section>
    </SectionContainer>
  );
};

export default CardSection;
